module.exports = __webpack_public_path__ + "static/media/markdown.b9277586.png";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/markdown.png
// module id = 79
// module chunks = 0